import { Component, EventEmitter, OnInit, Output , ChangeDetectorRef } from '@angular/core';
import { WizardStateService } from '../../../services/wizard-state.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-global-context-step-3',
    templateUrl: './global-context-step-3.component.html',
    styleUrls: ['./global-context-step-3.component.scss'],
    standalone: false
})
export class GlobalContextStep3Component implements OnInit {
  @Output() next = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  mapName = '';

  // Form Fields
  recentEvents = '';
  politicalOverview = '';
  globalConflicts = '';

  // Validation
  showErrorMsg = false;
  validationErrorText = '';

  constructor(private stateService: WizardStateService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.stateService.state.pipe(take(1)).subscribe(state => {
      this.mapName = state.mapName || 'World';

      // Restore values from state if they exist
      if (state.globalContext) {
        const gc = state.globalContext;
        this.recentEvents = gc.recentEvents || '';
        this.politicalOverview = gc.politicalOverview || '';
        this.globalConflicts = gc.globalConflicts || '';
      }
      this.cdr.detectChanges();
    });
  }

  onNext(): void {
    this.showErrorMsg = false;
    this.validationErrorText = '';

    // Validate fields
    if (!this.recentEvents.trim()) {
      this.validationErrorText = 'Recent Major Events is required.';
      this.showErrorMsg = true;
      return;
    }
    if (!this.politicalOverview.trim()) {
      this.validationErrorText = 'Political Overview is required.';
      this.showErrorMsg = true;
      return;
    }
    if (!this.globalConflicts.trim()) {
      this.validationErrorText = 'Global Conflicts/Tensions is required.';
      this.showErrorMsg = true;
      return;
    }

    // Save state
    this.stateService.updateState({
      globalContext: {
        ...this.stateService.currentState.globalContext,
        recentEvents: this.recentEvents,
        politicalOverview: this.politicalOverview,
        globalConflicts: this.globalConflicts
      }
    });

    this.next.emit();
  }

  onBack(): void {
    this.stateService.updateState({
      globalContext: {
        ...this.stateService.currentState.globalContext,
        recentEvents: this.recentEvents,
        politicalOverview: this.politicalOverview,
        globalConflicts: this.globalConflicts
      }
    });
    this.back.emit();
  }
}
